export enum EstadoPago {
  APROBADO = 'APROBADA',
  PENDIENTE = 'PENDIENTE',
  RECHAZADO = 'RECHAZADA',
  PETICION_ACTIVA = 'PETICION_ACTIVA',
  EXPIRADO = 'EXPIRADO',
}
